import { DomainLocale } from '../localization/types';
import { Nullable } from '../types/Nullable';

export interface Equipment {
  priority?: number;
  title: string;
  key?: string;
  description?: string | null;
}

export type TireType =
  | 'Sommardäck'
  | 'Summer tyres'
  | 'Odubbade vinterdäck'
  | 'Dubbade vinterdäck'
  | 'Sommardäck Runflat'
  | 'Studded winter tyres'
  | 'Unstudded winter tyres';

export const winterTireTypes: TireType[] = [
  'Odubbade vinterdäck',
  'Dubbade vinterdäck',
  'Studded winter tyres',
  'Unstudded winter tyres'
];

export type TireTypeKey =
  | 'SUMMER_TIRES'
  | 'SUMMER_TIRES_RUNFLAT'
  | 'UNSTUDDED_WINTER_TIRES'
  | 'STUDDED_WINTER_TIRES';

export const winterTireTypeKeys: TireTypeKey[] = [
  'UNSTUDDED_WINTER_TIRES',
  'STUDDED_WINTER_TIRES'
];

export interface Tires {
  other: {
    rimSize: string;
    rimType: string;
    tireType: TireType;
    tireTypeKey?: TireTypeKey;
    otherInfo: string;
  };
  grades: {
    rearLeft?: number;
    frontLeft?: number;
    rearRight?: number;
    frontRight?: number;
    left?: number; //vehicle_type=trailer
    right?: number; //vehicle_type=trailer
    front?: number; //vehicle_type=mc_moped - motorcycle
    rear?: number; //vehicle_type=mc_moped - motorcycle
  };
  treadDepths: {
    rearLeft?: number;
    frontLeft?: number;
    rearRight?: number;
    frontRight?: number;
    left?: number;
    right?: number;
    front?: number;
    rear?: number;
  };
}

export type ValuatorComment = Record<DomainLocale, string>;

export type GRADE_CATEGORY =
  | 'TOTAL'
  | 'BRAKES'
  | 'EXTERIOR'
  | 'INTERIOR'
  | 'ENGINE_AND_GEARBOX'
  | 'TECHNOLOGY_AND_EQUIPMENT'
  | 'BATTERY'
  | 'TIRES';

export type REMARK_CATEGORY =
  | 'BRAKES'
  | 'EXTERIOR'
  | 'INTERIOR'
  | 'ENGINE_AND_GEARBOX'
  | 'TECHNOLOGY_AND_EQUIPMENT'
  | 'BATTERY'
  | 'TIRES';
export interface Grade {
  max: number;
  min: number;
  value: number;
}

export interface Remark {
  id: string;
  key: string;
  category: REMARK_CATEGORY;
  text?: string;
  point?: number;
  deviationUuid?: string;
  other?: Nullable<string>;
}

export interface EndUserTestProtocol {
  grades: { [key in GRADE_CATEGORY]?: Grade };
  remarks: { [key in REMARK_CATEGORY]: Remark[] };

  tires: {
    mountedTires?: Tires;
    extraTires?: Tires;
  };

  towbar: boolean;
  textile: string;
  finishType: string;
  protocolId: string;
  createdAt: string;

  stoveFlames?: boolean | null;
  heatingSystem?: boolean | null;
  numberOfKeys: number;
  numberOfSeats: number;
  isRepairObject: boolean;

  serviceBookType?: string | null;
  serviceBookStatus?: string | null;

  odometerReadingAfterTest: {
    unit: string;
    value: number;
  };
  odometerReadingAfterTestInKm: number;

  equipment: Equipment[];

  boatType?: string | null;
  boatWidth?: string | null;
  boatEngine?: string | null;
  boatLength?: string | null;
  boatWeight?: string | null;
  boatEnginePower?: string | null;
  boatExteriorColor?: string | null;
  boatEngineSerialNumber?: string | null;
  boatCeBranded?: string | boolean;
  numberOfBunks?: string | null;
  boatGearModel?: string | null;
  boatEngineFuel?: string | null;
  boatSepticTank?: boolean | null;
}

export type ValuationCurrency = 'SEK';

export interface Valuation {
  id: number;
  processObjectId: string;

  endUserTestProtocol: EndUserTestProtocol;

  auctionPriceValuation: {
    currency: ValuationCurrency;
  };

  finalised: boolean;
  includedImageIds?: boolean | null;

  valuatorComment: ValuatorComment;
  valuatorCommentLocalized?: string;
  generatedValuatorComment: ValuatorComment;
  carDealerPrice: number;

  updatedAt: string;
  createdAt: string;
}
